import { WEBSITES } from '@/constants/config';

const isEnableTranslateKM =
    process.env.VUE_APP_ENABLE_TRANSLATE_KM?.toLowerCase() === 'true';
export default [
    {
        code: 'en',
        name: 'English',
        shortName: 'US',
        image: 'US.png',
        supportCountries: [WEBSITES.KH, WEBSITES.AE, WEBSITES.TH],
    },
    ...(isEnableTranslateKM
        ? [
              {
                  code: 'km',
                  name: 'Cambodian',
                  shortName: 'KH',
                  image: 'KH.png',
                  supportCountries: [WEBSITES.KH],
              },
          ]
        : []),
];
